(function () {
    'use strict';

    const GHOST_KEY = '5a914adc06241fec0669395c50';
    const GHOST_API = 'https://cms.pollingreport.uk/ghost/api/content/posts/';

    // Inject styles
    const style = document.createElement('style');
    style.textContent = `
#ukpr-search-overlay {
    position: fixed; inset: 0; z-index: 99999;
    background: rgba(0,0,0,0.55);
    display: flex; align-items: flex-start; justify-content: center;
    padding-top: 80px;
}
#ukpr-search-box {
    background: #fff; border-radius: 8px;
    width: 100%; max-width: 620px; margin: 0 16px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.22);
    overflow: hidden;
}
#ukpr-search-input-wrap {
    display: flex; align-items: center;
    padding: 0 16px; border-bottom: 1px solid #e5e7eb;
}
#ukpr-search-input-wrap svg { color: #9ca3af; flex-shrink: 0; }
#ukpr-search-input {
    flex: 1; border: none; outline: none;
    font-size: 1.1rem; padding: 14px 12px;
    font-family: inherit;
}
#ukpr-search-close {
    background: none; border: none; cursor: pointer;
    font-size: 1.4rem; color: #9ca3af; padding: 8px;
    line-height: 1;
}
#ukpr-search-close:hover { color: #374151; }
#ukpr-search-results { max-height: 60vh; overflow-y: auto; }
.ukpr-search-section-heading {
    font-size: 0.7rem; font-weight: 700; letter-spacing: 0.08em;
    text-transform: uppercase; color: #9ca3af;
    padding: 12px 16px 4px;
}
.ukpr-search-result {
    display: block; padding: 10px 16px;
    text-decoration: none; color: inherit;
    border-bottom: 1px solid #f3f4f6;
    transition: background 0.1s;
}
.ukpr-search-result:hover { background: #f9fafb; }
.ukpr-search-result:last-child { border-bottom: none; }
.ukpr-result-title { font-weight: 600; font-size: 0.95rem; color: #111827; }
.ukpr-result-sub { font-size: 0.8rem; color: #6b7280; margin-top: 2px; }
.ukpr-result-excerpt { font-size: 0.8rem; color: #6b7280; margin-top: 2px;
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
#ukpr-search-empty { padding: 24px 16px; text-align: center; color: #9ca3af; font-size: 0.9rem; }
`;
    document.head.appendChild(style);

    let overlay, input, resultsDiv;
    let debounceTimer = null;
    let currentQuery = '';

    function buildOverlay() {
        overlay = document.createElement('div');
        overlay.id = 'ukpr-search-overlay';
        overlay.setAttribute('role', 'dialog');
        overlay.setAttribute('aria-modal', 'true');

        overlay.innerHTML = `
<div id="ukpr-search-box">
  <div id="ukpr-search-input-wrap">
    <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z"/>
    </svg>
    <input id="ukpr-search-input" type="search" placeholder="Search articles, constituencies, MPs…" autocomplete="off"/>
    <button id="ukpr-search-close" aria-label="Close search">×</button>
  </div>
  <div id="ukpr-search-results"></div>
</div>`;

        document.body.appendChild(overlay);
        input = overlay.querySelector('#ukpr-search-input');
        resultsDiv = overlay.querySelector('#ukpr-search-results');

        overlay.querySelector('#ukpr-search-close').addEventListener('click', closeSearch);
        overlay.addEventListener('click', function (e) {
            if (e.target === overlay) closeSearch();
        });
        input.addEventListener('input', onInput);

        document.addEventListener('keydown', onKeydown);
        input.focus();
    }

    function closeSearch() {
        if (overlay) {
            overlay.remove();
            overlay = null;
        }
        document.removeEventListener('keydown', onKeydown);
        clearTimeout(debounceTimer);
    }

    function onKeydown(e) {
        if (e.key === 'Escape') closeSearch();
    }

    function onInput() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(runSearch, 300);
    }

    function runSearch() {
        const q = input.value.trim();
        if (q === currentQuery) return;
        currentQuery = q;

        if (q.length < 2) {
            resultsDiv.innerHTML = '';
            return;
        }

        resultsDiv.innerHTML = '<div id="ukpr-search-empty">Searching…</div>';

        fetch('/api/v1/search?q=' + encodeURIComponent(q))
            .then(r => r.ok ? r.json() : [])
            .catch(() => [])
            .then(results => renderResults(results, q));
    }

    function renderResults(results, q) {
        if (!overlay) return;
        let html = '';

        const seats = results.filter(r => r.type === 'seat' || r.type === 'candidate');
        const articles = results.filter(r => r.type === 'article');

        if (seats.length) {
            html += '<div class="ukpr-search-section-heading">Constituencies, MPs &amp; Candidates</div>';
            seats.forEach(function (s) {
                const sub = s.type === 'candidate'
                    ? 'Candidate: ' + (s.detail || s.code)
                    : (s.detail || s.code);
                html += '<a class="ukpr-search-result" href="' + s.url + '">' +
                    '<div class="ukpr-result-title">' + esc(s.name) + '</div>' +
                    '<div class="ukpr-result-sub">' + esc(sub) + '</div>' +
                    '</a>';
            });
        }

        if (articles.length) {
            html += '<div class="ukpr-search-section-heading">Articles</div>';
            articles.forEach(function (p) {
                html += '<a class="ukpr-search-result" href="' + esc(p.url) + '">' +
                    '<div class="ukpr-result-title">' + esc(p.name) + '</div>' +
                    (p.detail ? '<div class="ukpr-result-excerpt">' + esc(p.detail) + '</div>' : '') +
                    '</a>';
            });
        }

        if (!html) {
            html = '<div id="ukpr-search-empty">No results for <em>' + esc(q) + '</em></div>';
        }

        resultsDiv.innerHTML = html;
    }

    function esc(str) {
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    function openSearch(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (!overlay) {
            currentQuery = '';
            buildOverlay();
        }
    }

    // Intercept [data-ghost-search] buttons in capture phase to suppress sodo-search
    document.addEventListener('click', function (e) {
        const btn = e.target.closest('[data-ghost-search]');
        if (btn) openSearch(e);
    }, true);

}());
